module.exports = __webpack_public_path__ + "static/media/wand2.53d5d3f6.png";